<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import astharaIcon from 'dashboard/assets/images/asthara-icon.png';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-bind="attrs"
    :src="globalConfig.logoThumbnail || astharaIcon"
  />
</template>
